const MINUTES_PER_HOUR = 60;

export const convertMinutesToHours = (minutes: number) => minutes / MINUTES_PER_HOUR;
